import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { SelectionModel } from '@angular/cdk/collections';
import { ConexionService } from 'src/app/servicios/conexion.service';
import { UtilidadesService } from 'src/app/servicios/utilidades.service';
import { ActivatedRoute } from '@angular/router';


export interface Familias {
  Nombre: string;
  Usuario: string;
}



@Component({
  selector: 'app-tabla-user-familia',
  templateUrl: './tabla-user-familia.component.html',
  styleUrls: ['./tabla-user-familia.component.scss'],
})
export class TablaUserFamiliaComponent implements OnInit {

  displayedColumns: string[] = ['select', 'Nombres', 'Email', 'Validado', 'Estado', 'FechaActividad'];
  dataSource: MatTableDataSource<Familias>;
  selection = new SelectionModel<Familias>(true, []);

  Hijos = []
  Pagos = []
  filtro = "";
  CodigoFamilia=""
  Familia:any={Estado:-1};

  openmodal = false;
  Info:any;
  Detalles = []

  UserID = ""

  DatosMensualidades = []

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  constructor(private conexion: ConexionService, public utilidades: UtilidadesService, private activated: ActivatedRoute) {
    this.dataSource = new MatTableDataSource([])
  }

  ngOnInit() { 
    this.CodigoFamilia = this.activated.snapshot.paramMap.get("CodigoFamilia")
    this.getUsuariosFamilia(this.CodigoFamilia)
    this.getHijosFamilia(this.CodigoFamilia)
    this.getFamilia()
    this.getLogsDetallePagosPorFamilia()
  }

  getLogsDetallePagosPorFamilia() {
    this.conexion.getLogsDetallePagosPorFamilia([this.CodigoFamilia]).subscribe((resp) => {
      console.log(resp)
      if (resp.Respuesta == "Exito") {
        this.Pagos = resp.Datos
      }
    }, (err) => {
      this.utilidades.Depuracion(err.error.Mensaje, "", err.error.Codigo)

      this.utilidades.ValidarUser(err)
    })
  }


  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }


  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    this.isAllSelected() ?
      this.selection.clear() :
      this.dataSource.data.forEach(row => this.selection.select(row));
  }

  getUsuariosFamilia(cod:string) {
    this.utilidades.Loading("Cargando usuarios")
    this.conexion.getUsuariosFamilia(cod).subscribe((resp) => {
      this.utilidades.CerrarLoading()
      this.utilidades.Depuracion(resp, "console", "")
      if (resp.Respuesta == "Exito") {
        this.dataSource = new MatTableDataSource(resp.Datos);
        this.UserID = resp.Datos[0]["Id"]
        this.ngAfterViewInit()
        this.getMensualidadMisEstudiantesPagos()
      }
    }, (err) => {
      this.utilidades.CerrarLoading()
      this.utilidades.Depuracion(err.error.Mensaje, "", err.error.Codigo)

      this.utilidades.ValidarUser(err)
    })
  }


 
  getMensualidadMisEstudiantesPagos() {
    this.conexion.getMensualidadMisEstudiantes(this.UserID).subscribe((resp) => {
      this.utilidades.Depuracion(resp, "console", "")
      console.log(resp)
      if (resp.Respuesta == "Exito") {
        let d = resp.Datos
        let dm = []
        for(let i of d){
          if(i.CodigoFamilia == this.CodigoFamilia){
            dm.push(i)
          }
        }

        this.DatosMensualidades = dm

        this.utilidades.Depuracion(resp.Datos, "console", "")
      }
    }, (err) => {

      this.utilidades.ValidarUser(err)
    })
  }

  getHijosFamilia(cod:string) {
    this.conexion.getHijosFamilia(cod).subscribe((resp) => {
      if (resp.Respuesta == "Exito") {
        this.Hijos = resp.Datos;
      }
    }, (err) => {
      this.utilidades.Depuracion(err.error.Mensaje, "", err.error.Codigo)

      this.utilidades.ValidarUser(err)
    })
  }

  CambiarEstado(estado) {

    let datos = { Familias: [{CodigoFamilia: this.CodigoFamilia}], Estado: estado }

    this.conexion.CambiarEstadoFamilias(datos).subscribe((resp) => {
      this.utilidades.Toast(resp.Mensaje)
      this.getFamilia()
    }, (err) => {
      if (err.error.Respuesta == "Advertencia") {
        this.utilidades.Alerta(JSON.stringify(datos), "Aceptar", err.error.Mensaje)
      } else {
        this.utilidades.Depuracion(err.error.Mensaje, "", err.error.Codigo)
      }

      this.utilidades.ValidarUser(err)
    })
  }


  GenerarCodigo(validarV=true) {

    let datos = { Familias: [this.Familia], "ValidarVencimiento": validarV}
    console.clear()
    this.utilidades.Depuracion(datos, "console", "")
    this.conexion.GenerarCodigoFamilias(datos).subscribe((resp) => {
      this.utilidades.Toast(resp.Mensaje)
      localStorage.setItem("FamiliasImprecion", JSON.stringify(resp.Generados))
      this.utilidades.Depuracion(resp.Generados, "console", "")
      this.utilidades.Nav('/documento-cod-familia')
    }, (err) => {
      if (err.error.Respuesta == "Advertencia") {
        if (err.error.Codigo == "GCF001") {
          if (confirm(err.error.Mensaje)) {
            this.GenerarCodigo(false)
          }
          return 0
        }
        this.utilidades.Alerta(JSON.stringify(datos), "Aceptar", err.error.Mensaje)
      } else {
        this.utilidades.Depuracion(err.error.Mensaje, "", err.error.Codigo)
      }

      this.utilidades.ValidarUser(err)
    })
  }


  DesvincularUsuarios(){
    if (!this.selection.selected){
      this.utilidades.Alerta("No hay usuarios seleccionados")
      return 0;
    }

    let datos = {Usuarios: this.selection.selected, CodigoFamilia: this.CodigoFamilia}

    this.conexion.DesvincularUsuarioFamilia(datos).subscribe((resp) =>{
      this.utilidades.Toast(resp.Mensaje)
      this.getUsuariosFamilia(this.CodigoFamilia)
    }, (err) => {
      this.utilidades.Depuracion(err.error.Mensaje, "", err.error.Codigo)

      this.utilidades.ValidarUser(err)
    })

  }


  getFamilia() {
    this.conexion.getFamilia(this.CodigoFamilia).subscribe((resp) => {
      this.utilidades.Depuracion(resp, "console", "")
      if (resp.Respuesta == "Exito") {
      this.Familia=resp.Datos;
        
      }
    }, (err) => {
      this.utilidades.Depuracion(err.error.Mensaje, "", err.error.Codigo)

      this.utilidades.ValidarUser(err)
    })
  }

  ReenviarCorreoDocumentosPagos(id_flujo) {
    this.utilidades.Loading("Enviando correo")
    this.conexion.ReenviarCorreoDocumentosPagos(id_flujo).subscribe((resp) => {
      this.utilidades.CerrarLoading()
      this.utilidades.Alerta(resp.Mensaje)
    }, (err) => {
      this.utilidades.CerrarLoading()
      this.utilidades.Depuracion(err.error.Mensaje, "", err.error.Codigo)
      this.utilidades.ValidarUser(err)
    })
  }

  MarcarComoPagoLosDocumentos(id_flujo, id_cobro) {
    let fecha = ""
    for(let i of this.Detalles){
      if(i.Estado==2){
        fecha = JSON.parse(i.Respuesta).Cuerpo.submitTimeUtc
      }
    }
    
    this.utilidades.Loading("Realizando procedimiento")
    this.conexion.MarcarComoPagoLosDocumentos(id_flujo, id_cobro, fecha).subscribe((resp) => {
      this.utilidades.CerrarLoading()
      this.utilidades.Alerta(resp.Mensaje)
      this.getLogsDetallePagosPorFamilia()
    }, (err) => {
      this.utilidades.CerrarLoading()
      this.utilidades.Depuracion(err.error.Mensaje, "", err.error.Codigo)
      this.utilidades.ValidarUser(err)
    })
  }

  DesmarcarDocumentos(id_flujo, id_cobro, tipo) {

    if(!id_cobro){
      id_cobro = prompt("Ingresa el id de cobro de esta transacción")
    }else if(id_cobro == 'sin cobro'){
      if(!confirm("Esta acción no se comunicará con Colleger, sino que marcará este proceso de pago con el estado “Documentos desbloqueados”. Debe asegurarse de que Colleger tenga la información correcta respecto a estos documentos. ¿Desea continuar?"))
      return 0;
    }

    this.utilidades.Loading("Realizando procedimiento")
    this.conexion.DesmarcarDocumentos(id_flujo, id_cobro, "", tipo).subscribe((resp) => {
      this.utilidades.CerrarLoading()
      this.utilidades.Alerta(resp.Mensaje)
      this.getLogsDetallePagosPorFamilia()
    }, (err) => {
      this.utilidades.CerrarLoading()
      this.utilidades.Depuracion(err.error.Mensaje, "", err.error.Codigo)
      this.utilidades.ValidarUser(err)
    })
  }
}
